export enum IDV_ERROR_CODE {
    FAILED = 'FAILED',
    LOCKED = 'LOCKED'
}
